import {GlobalMakerService} from "~/core/services/GlobalMakerService";
import {diagLog} from "~/core/services/utils/Constants";

export class TranslationHelper {
    static translate(key, params) {
        diagLog(this, 'fetching translation for => ', key);
        return GlobalMakerService.$i18n.t(key, { ...params });
    }
}
